/**
 * Mixin, die MorphoDB für alle Komponenten bereitstellt
 */
export let providesMorphoDBMixin = {
    data: function () {
        return {
            MorphoDB: {}
        }
    },
    mounted: async function () {
        this.MorphoDB = window.MorphoDB;

    }
}